import { I18n } from "i18n-js";
import translations from "../locales.json";

const i18n = new I18n(translations);

i18n.enableFallback = true;
i18n.missingTranslationPrefix = "Missing translation: ";
i18n.defaultLocale = window.itms.defaultLocale;
i18n.locale = window.itms.locale;

export default i18n;
